import React, {
  useEffect,
  useCallback,
  Suspense,
  lazy,
} from "react";

import "../Manage Projects/viewProjects.css";
import "./viewNewsBrand.css";

import { Link, useParams } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";

import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";

import { viewNewsBrand } from "../../Redux/Actions/newsBrandAction";

const SearchBar = lazy(() => import("../Main/searchBar"));
const NewsBrandContent = lazy(() => import("./newsBrandContent"));

const ViewNewsBrand = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { singleNewsBrand, loading } = useSelector((state) => state.newsBrand);
  const data = singleNewsBrand?.data;
  console.log("DATATA", data)

  useEffect(() => {
    if (!id) return;
    if (data?._id === id) return;

    dispatch(viewNewsBrand(id)).catch(() => {
      toast.error("Failed to load news brand details.");
    });
  }, [id, dispatch, data]);

  const formatDate = useCallback((dateString) => {
    if (!dateString) return "Not specified";

    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }, []);

  if (loading) {
    return (
      <div className="loading-wrapper">
        <div className="loading-content">
          <div className="spinner"></div>
          <p className="loading-text">Loading news brand details...</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="padding-20 gap-10 grid-container"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(7, 1fr)",
        gridAutoRows: "minmax(60px, auto)",
        background: "#F5F7FA",
      }}
    >
      <div style={{ gridColumn: "4/8" }}>
        <Suspense fallback={null}>
          <SearchBar style={{ width: "max-content" }} />
        </Suspense>
      </div>

      <div className="header-section">
        <Link to="/news_brand">
          <BackIcon style={{ cursor: "pointer" }} />
        </Link>

        <div className="title-wrapper">
          <h1>News Brand Details</h1>
          <p>News Brands / List / View</p>
        </div>
      </div>

      <Suspense
        fallback={
          <div className="main-content">
            <p className="loading-text">Loading content...</p>
          </div>
        }
      >
        {data && (
          <NewsBrandContent
            data={data}
            formatDate={formatDate}
          />
        )}
      </Suspense>
    </div>
  );
};

export default ViewNewsBrand;
